export default "__VITE_ASSET__C22j0vjs__"